import { mapApiBankLotToLot, mapApiToLot } from 'src/adapters';
import { doGet } from 'src/api/axios-config';
import { ApiRoute } from 'src/constants';
import type { IApiBankLot, IApiLot } from 'src/interfaces';

export async function fetchLots(params: { [propName: string]: string }) {
  try {
    const result = await doGet<IApiLot[]>(ApiRoute.LOTS, {
      params,
    });

    if (process.env.NODE_ENV === 'development') {
      // remove lots with broken location data from list
      return (
        result.data
          ?.filter(
            (item) => !!item.location?.coordinates || !!item.mausoleum?.location?.coordinates
          )
          .map(mapApiToLot) || null
      );
    }

    return result.data?.map(mapApiToLot) || null;
  } catch (err: any) {
    console.log(err);
    return null;
  }
}

export async function fetchBankLots(bankId: string) {
  try {
    const result = await doGet<IApiBankLot[]>(ApiRoute.BANK_LOTS(bankId));
    return result.data?.map(mapApiBankLotToLot) || null;
  } catch (err: any) {
    console.log(err);
    return null;
  }
}

export async function fetchLotById(id: string) {
  try {
    const result = await doGet<IApiLot>(ApiRoute.LOT(id));

    if (result.data) {
      return mapApiToLot(result.data);
    } else {
      return null;
    }
  } catch (err: any) {
    console.log(err);
    return null;
  }
}
